import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ButtonIconH from "./ButtonIconH";
import Dropdown from "./Dropdown";
import InputData from "./InputData";
import CheckBox from "./CheckBox";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import Tag from "./Tag";
import { post } from "../js/post";
import {
  focusElement,
  recalcularDesdePCB,
  recalcularDesdePCN,
  recalcularDesdePorcDescuento,
  recalcularDesdePorcIVA,
  selectedOptic,
  userData,
} from "../js/utils";
import { useBrands } from "../hooks/useBrands";

export function ProductPurchaseData({
  productFamilyId,
  productFamilyName,
  list,
  columns,
  onProductChange,
  tabStartIndex,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [productList, setProductList] = useState(list);
  const [selectedItems, setSelectedItems] = useState([]);
  const [newPCB, setNewPCB] = useState("");
  const [newDTO, setNewDTO] = useState("");
  const [newPCN, setNewPCN] = useState("");
  const [IvaList, setIvaList] = useState([]);
  const [selectedVAT, setSelectedVAT] = useState("");
  const [surchargeValue, setSurchargeValue] = useState("");
  const [brandList] = useBrands(productFamilyId, -1, "");
  const [selectedBrandList, setSelectedBrandList] = useState([]);


  const [currentSummary, setCurrentSummary] = useState({
    idProductoAlbaran: "summary",
    pvp: 0,
    pcn: 0,
    iva: 0,
    stock: 0,
    totalCompra: 0,
    recargo: 0,
    pcu: 0,
  });

  // console.log("productList: ", productList);

  async function getIVAListSurcharge() {
    const response = await post("ListarTiposIVAconRecargo.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
    });
    const list = response.tiposIVA.map((e) => ({
      id: e.tipoIVA,
      text: e.tipoIVA.toString(),
      surcharge: e.recargo,
    }));
    setIvaList(list);
  }

  async function getIVA() {
    const response = await post("ObtenerTipoIVA.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      familia: productFamilyId,
    });
    if (response.tipoIVA) {
      setSelectedVAT(response.tipoIVA);
    }
  }

  function calculateUpdatedProductNEW(product, data) {
    const updatedData = {
      ...data,
      pcb: Number(data.pcb !== "" ? data.pcb : product.pcb),
      pcn: Number(data.pcn !== "" ? data.pcn : product.pcn),
      porcDescuento: Number(
        data.porcDescuento !== "" ? data.porcDescuento : product.descuento,
      ),
      pcu: product.pcu,
      stock: product.stock,
      total: product.totalCompra,
    };

    let recalculatedData = null;

    if (data.pcb !== "") {
      recalculatedData = recalcularDesdePCB(Number(data.pcb), updatedData);
    } else if (data.pcn !== "") {
      recalculatedData = recalcularDesdePCN(Number(data.pcn), updatedData);
    } else if (data.porcDescuento !== "") {
      recalculatedData = recalcularDesdePorcDescuento(
        Number(data.porcDescuento),
        updatedData,
      );
    } else {
      recalculatedData = recalcularDesdePorcIVA(
        Number(data.porcIVA),
        updatedData,
      );
    }

    return {
      ...product,
      pcb: recalculatedData.pcb,
      pcn: recalculatedData.pcn,
      descuento: recalculatedData.porcDescuento,
      recargo: recalculatedData.re,
      tipoRecargo: recalculatedData.porcRE,
      tipoIva: recalculatedData.porcIVA,
      iva: recalculatedData.iva,
      stock: recalculatedData.stock,
      pcu: recalculatedData.pcu,
      totalCompra: recalculatedData.total,
    };
  }

  function handleValueChange(productId, field, newValue) {
    setProductList((prevList) => {
      const updatedList = prevList.map((product) =>
        product.idProductoAlbaran === productId
          ? { ...product, [field]: newValue }
          : product,
      );

      return handleProductSummary(updatedList);
    });
  }

  const handleProductSummary = (updatedList) => {
    const totalPCN = updatedList.reduce((sum, item) => {
      return item.idProductoAlbaran !== "summary"
        ? sum + parseFloat(item.pcn)
        : sum;
    }, 0);

    const totalPCU = updatedList.reduce((sum, item) => {
      return item.idProductoAlbaran !== "summary" ? sum + item.pcu : sum;
    }, 0);

    const totalPVP = updatedList.reduce((sum, item) => {
      return item.idProductoAlbaran !== "summary" ? sum + item.pvp : sum;
    }, 0);

    const totalIVA = updatedList.reduce((sum, item) => {
      return item.idProductoAlbaran !== "summary" ? sum + item.iva : sum;
    }, 0);

    const totalStock = updatedList.reduce((sum, item) => {
      return item.idProductoAlbaran !== "summary" ? sum + item.stock : sum;
    }, 0);

    const totalRecargo = updatedList.reduce((sum, item) => {
      return item.idProductoAlbaran !== "summary" ? sum + item.recargo : sum;
    }, 0);

    const totalTotal = updatedList.reduce((sum, item) => {
      return item.idProductoAlbaran !== "summary"
        ? sum + item.totalCompra
        : sum;
    }, 0);

    const summaryIndex = updatedList.findIndex(
      (e) => e.idProductoAlbaran === "summary",
    );

    if (summaryIndex !== -1) {
      return updatedList.map((e, index) => {
        if (index === summaryIndex) {
          const summary = {
            idProductoAlbaran: "summary",
            pvp: parseFloat(totalPVP.toFixed(2)),
            pcn: parseFloat(totalPCN.toFixed(2)),
            iva: parseFloat(totalIVA.toFixed(2)),
            stock: totalStock,
            recargo: parseFloat(totalRecargo.toFixed(2)),
            pcu: parseFloat(totalPCU.toFixed(2)),
            totalCompra: parseFloat(totalTotal.toFixed(2)),
          };
          setCurrentSummary(summary);
          return summary;
        }
        return e;
      });
    }

    return updatedList;
  };

  function handleCheckboxChange(productId) {
    setSelectedItems((prevSelected) =>
      prevSelected.includes(productId)
        ? prevSelected.filter((id) => id !== productId)
        : [...prevSelected, productId],
    );
  }

  const isValidInput = (value) => {
    const regex = /^\d*\.?\d*$/; // Números y caracter punto.
    return regex.test(value);
  };

  const columnsWithInputs = columns.map((col) => {
    if (col.name === "PCB") {
      return {
        ...col,
        cell: (row, rowIndex) =>
          row.idProductoAlbaran !== "summary" ? (
            <InputData
              size={0}
              type="type-float2"
              tabIndex={tabStartIndex + 5 + rowIndex * 3}
              input={row.pcb}
              onChange={(e) => {
                if (isValidInput(e)) {
                  handleValueChange(row.idProductoAlbaran, "pcb", e);
                }
              }}
              onBlur={(e) => {
                const value = e === "" ? "0" : e;
                const data = {
                  ...row,
                  pcb: value,
                  pcn: row.pcn,
                  porcDescuento: row.descuento,
                  porcRE: surchargeValue,
                  porcIVA: selectedVAT,
                  iva: row.iva,
                  re: row.recargo,
                  pcu: row.pcu,
                  stock: row.stock,
                  total: row.totalCompra,
                };
                const updatedData = recalcularDesdePCB(value, data);
                setProductList((prevList) => {
                  const updatedList = prevList.map((product) =>
                    product.idProductoAlbaran === row.idProductoAlbaran
                      ? {
                          ...product,
                          pcb: updatedData.pcb,
                          pcn: updatedData.pcn,
                          descuento: updatedData.porcDescuento,
                          iva: updatedData.iva,
                          recargo: updatedData.re,
                          pcu: updatedData.pcu,
                          totalCompra: updatedData.total,
                        }
                      : product,
                  );

                  return handleProductSummary(updatedList);
                });
              }}
            />
          ) : (
            ""
          ),
      };
    }

    if (col.name === "DTO %") {
      return {
        ...col,
        cell: (row, rowIndex) =>
          row.idProductoAlbaran !== "summary" ? (
            <InputData
              size={0}
              type="type-positive-float"
              tabIndex={tabStartIndex + 5 + rowIndex * 3 + 1}
              input={row.descuento}
              onChange={(e) => {
                if (isValidInput(e)) {
                  handleValueChange(row.idProductoAlbaran, "descuento", e);
                }
              }}
              onBlur={(e) => {
                const value = e === "" ? "0" : e;
                const data = {
                  ...row,
                  pcb: row.pcb,
                  pcn: row.pcn,
                  porcDescuento: value,
                  porcRE: surchargeValue,
                  porcIVA: selectedVAT,
                  iva: row.iva,
                  re: row.recargo,
                  pcu: row.pcu,
                  stock: row.stock,
                  total: row.totalCompra,
                };
                const updatedData = recalcularDesdePorcDescuento(value, data);
                setProductList((prevList) => {
                  const updatedList = prevList.map((product) =>
                    product.idProductoAlbaran === row.idProductoAlbaran
                      ? {
                          ...product,
                          pcb: updatedData.pcb,
                          pcn: updatedData.pcn,
                          descuento: updatedData.porcDescuento,
                          iva: updatedData.iva,
                          recargo: updatedData.re,
                          pcu: updatedData.pcu,
                          totalCompra: updatedData.total,
                        }
                      : product,
                  );

                  return handleProductSummary(updatedList);
                });
              }}
            />
          ) : (
            ""
          ),
      };
    }

    if (col.name === "PCN") {
      return {
        ...col,
        cell: (row, rowIndex) => {
          const applyPCN = (e) => {
            const value = e === "" ? "0" : e;
            if (parseFloat(value) > parseFloat(row.pcb)) {
              showPCNErrorPopup();
              return;
            }
            const data = {
              ...row,
              pcb: row.pcb,
              pcn: value,
              porcDescuento: row.descuento,
              porcRE: surchargeValue,
              porcIVA: selectedVAT,
              iva: row.iva,
              re: row.recargo,
              pcu: row.pcu,
              stock: row.stock,
              total: row.totalCompra,
            };
            const updatedData = recalcularDesdePCN(value, data);
            setProductList((prevList) => {
              const updatedList = prevList.map((product) =>
                product.idProductoAlbaran === row.idProductoAlbaran
                  ? {
                      ...product,
                      pcb: updatedData.pcb,
                      pcn: updatedData.pcn,
                      descuento: updatedData.porcDescuento,
                      iva: updatedData.iva,
                      recargo: updatedData.re,
                      pcu: updatedData.pcu,
                      totalCompra: updatedData.total,
                    }
                  : product,
              );
              return handleProductSummary(updatedList);
            });
          };

          return row.idProductoAlbaran !== "summary" ? (
            <InputData
              size={0}
              type="type-float2"
              tabIndex={tabStartIndex + 5 + rowIndex * 3 + 2}
              input={row.pcn}
              onChange={(e) => {
                if (isValidInput(e)) {
                  handleValueChange(row.idProductoAlbaran, "pcn", e);
                }
              }}
              onBlur={applyPCN}
              onEnter={() => {
                applyPCN(row.pcn);
                focusElement(tabStartIndex + 5 + rowIndex * 3 + 3);
              }}
            />
          ) : (
            ""
          );
        },
      };
    }

    if (col.name === "") {
      return {
        ...col,
        selector: (row) =>
          row.idProductoAlbaran !== "summary" ? (
            <CheckBox
              active={selectedItems.includes(row.idProductoAlbaran)}
              onClick={() => handleCheckboxChange(row.idProductoAlbaran)}
            />
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  function showPCNErrorPopup() {
    createPopupQuestion(
      "El PCN no puede ser mayor al PCB.",
      removePopupQuestion,
      null,
      "Entendido",
    );
  }

  function handleNewPCB(e) {
    setNewPCB(e);
  }

  function handleNewPCN(e) {
    setNewPCN(e);
  }

  function handleNewDTO(e) {
    setNewDTO(e);
  }

  function handleSelectAll() {
    setSelectedItems((prev) => [
      ...prev,
      ...productList
        .filter(
          ({ idProductoAlbaran }) =>
            idProductoAlbaran !== "summary" &&
            !prev.includes(idProductoAlbaran),
        )
        .map(({ idProductoAlbaran }) => idProductoAlbaran),
    ]);
  }

  function handleCleanSelected() {
    setSelectedItems([]);
  }

  function handleCleanValues() {
    setNewPCB("");
    setNewDTO("");
    setNewPCN("");
    setSelectedBrandList([]);
    focusElement(tabStartIndex + 1);
  }

  function applyToAll() {
    if (newPCN !== "") {
      const pcbToCompare = newPCB !== "" ? parseFloat(newPCB) : null;
      const affectedProducts = productList.filter(
        (p) =>
          p.idProductoAlbaran !== "summary" &&
          (selectedBrandList.length === 0 || selectedBrandList.includes(p.marca)),
      );
      const hasInvalid = affectedProducts.some((p) => {
        const pcb = pcbToCompare !== null ? pcbToCompare : parseFloat(p.pcb);
        return parseFloat(newPCN) > pcb;
      });
      if (hasInvalid) {
        showPCNErrorPopup();
        return;
      }
    }

    const data = {
      pcb: newPCB,
      pcn: newPCN,
      porcDescuento: newDTO,
      porcRE: surchargeValue,
      porcIVA: selectedVAT,
    };

    setProductList((prevList) => {
      const updatedList = prevList.map((product) => {
        const isSummary = product.idProductoAlbaran === "summary";
        const brandIsIncluded =
          selectedBrandList.length === 0 ||
          selectedBrandList.includes(product.marca);

        if (!isSummary && brandIsIncluded) {
          return calculateUpdatedProductNEW(product, data);
        }

        return product;
      });

      return handleProductSummary(updatedList);
    });
  }

  function applyToSelection() {
    if (newPCN !== "") {
      const pcbToCompare = newPCB !== "" ? parseFloat(newPCB) : null;
      const affectedProducts = productList.filter(
        (p) =>
          p.idProductoAlbaran !== "summary" &&
          selectedItems.includes(p.idProductoAlbaran) &&
          (selectedBrandList.length === 0 || selectedBrandList.includes(p.marca)),
      );
      const hasInvalid = affectedProducts.some((p) => {
        const pcb = pcbToCompare !== null ? pcbToCompare : parseFloat(p.pcb);
        return parseFloat(newPCN) > pcb;
      });
      if (hasInvalid) {
        showPCNErrorPopup();
        return;
      }
    }

    const data = {
      pcb: newPCB,
      pcn: newPCN,
      porcDescuento: newDTO,
      porcRE: surchargeValue,
      porcIVA: selectedVAT,
    };

    setProductList((prevList) => {
      const updatedList = prevList.map((product) => {
        const isSummary = product.idProductoAlbaran === "summary";
        const isSelected = selectedItems.includes(product.idProductoAlbaran);
        const brandIsIncluded =
          selectedBrandList.length === 0 ||
          selectedBrandList.includes(product.marca);

        if (!isSummary && isSelected && brandIsIncluded) {
          return calculateUpdatedProductNEW(product, data);
        }

        return product;
      });

      setSelectedItems([]);
      return handleProductSummary(updatedList);
    });
  }

  function validateSelectedProducts() {
    setProductList((prevList) =>
      prevList.map((product) =>
        product.idProductoAlbaran !== "summary" &&
        selectedItems.includes(product.idProductoAlbaran)
          ? { ...product, validadoDatosCompra: true }
          : product,
      ),
    );
    setSelectedItems([]);
  }

  useEffect(() => {
    if (newPCB !== "") setNewPCN("");
  }, [newPCB]);

  useEffect(() => {
    if (newPCN !== "") setNewPCB("");
  }, [newPCN]);

  useEffect(() => {
    const fetchData = async () => {
      await getIVAListSurcharge();
      await getIVA();
    };

    fetchData();
  }, []);

  useEffect(() => {
    const found = IvaList.find((e) => e.id === selectedVAT);
    if (found) {
      setSurchargeValue(found.surcharge);
    }
  }, [selectedVAT]);

  useEffect(() => {
    const hasSummary = productList.some(
      (item) => item.idProductoAlbaran === "summary",
    );

    if (productList.length > 0 && !hasSummary) {
      const recalculatedList = productList.map((item) => ({
        ...item,
        totalCompra: parseFloat((item.pcu * item.stock).toFixed(2)),
      }));

      // Si no existe, agregar la fila de resumen
      const summaryRow = {
        idProductoAlbaran: "summary",
        pvp: recalculatedList.reduce((sum, item) => sum + item.pvp, 0),
        pcn: recalculatedList.reduce((sum, item) => sum + item.pcn, 0),
        iva: recalculatedList.reduce((sum, item) => sum + item.iva, 0),
        stock: recalculatedList.reduce((sum, item) => sum + item.stock, 0),
        totalCompra: recalculatedList.reduce(
          (sum, item) => sum + item.totalCompra,
          0,
        ),
        recargo: recalculatedList.reduce((sum, item) => sum + item.recargo, 0),
        pcu: recalculatedList.reduce((sum, item) => sum + item.pcu, 0),
      };

      // Actualizar el estado de productList incluyendo la fila de resumen
      setProductList([...recalculatedList, summaryRow]);
      setCurrentSummary(summaryRow);
    }
  }, []);

  useEffect(() => {
    onProductChange(
      productFamilyId,
      currentSummary,
      productList,
      selectedVAT,
      surchargeValue,
    );
  }, [currentSummary]);

  useEffect(() => {
    const filteredProducts = productList.filter((item) => {
      if (item.idProductoAlbaran === "summary") return true;
      if (selectedBrandList.length === 0) return true;
      return selectedBrandList.includes(item.marca);
    });

    handleProductSummary(filteredProducts);
  }, [selectedBrandList, productList]);

  return (
    <>
      {list.length > 0 && (
        <div className="delivery-note-table-info-container">
          <div className="opt-table-title">
            {productFamilyName} ({list.length})
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <button
              className="cell-label"
              onClick={handleCleanValues}
              tabIndex={-1}
            >
              Limpiar valores
            </button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              padding: "10px 0 10px 0",
            }}
          >
            <div className="data-field">
              <span className="label">IVA %</span>
              <Dropdown
                tabIndex={tabStartIndex}
                optionList={IvaList}
                size={4}
                op={selectedVAT}
                onChange={(e) => {
                  setSelectedVAT(e.id);
                }}
              ></Dropdown>
            </div>
            <div className="data-field">
              <span className="label">Recargo %</span>
              <InputData
                type="type-float2"
                size={4}
                inactive={true}
                input={surchargeValue}
                onChange={() => {}}
              ></InputData>
            </div>
            <div className="data-field">
              <span className="label">Añadir PCB</span>
              <InputData
                tabIndex={tabStartIndex + 1}
                type="type-float2"
                size={1}
                input={newPCB}
                onChange={handleNewPCB}
              ></InputData>
            </div>
            <div className="data-field">
              <span className="label">Añadir DTO %</span>
              <InputData
                tabIndex={tabStartIndex + 2}
                type="type-positive-float"
                size={5}
                input={newDTO}
                onChange={handleNewDTO}
              ></InputData>
            </div>
            <div className="data-field">
              <span className="label">Añadir PCN</span>
              <InputData
                tabIndex={tabStartIndex + 3}
                type="type-float2"
                size={1}
                input={newPCN}
                onChange={handleNewPCN}
              ></InputData>
            </div>
            <div className="data-field" style={{ flex: 1 }}>
              <span className="label">Marca</span>
              <InputIconSearchPanelMultiSelection
                size={0}
                tabIndex={tabStartIndex + 4}
                type={"type-alphanum-ext"}
                options={brandList.filter((brand) => productList.some((p) => p.marca === brand))}
                selectedOptions={selectedBrandList}
                onChange={(e) => {
                  setSelectedBrandList(e);
                }}
              ></InputIconSearchPanelMultiSelection>
            </div>
            <ButtonIconH
              text={"Aplicar a todos"}
              small={true}
              onClick={applyToAll}
            ></ButtonIconH>
            <ButtonIconH
              disabled={selectedItems.length === 0}
              text={"Aplicar a selección"}
              small={true}
              onClick={applyToSelection}
            ></ButtonIconH>
            <ButtonIconH
              disabled={selectedItems.length === 0}
              text={"Validar"}
              small={true}
              onClick={validateSelectedProducts}
            ></ButtonIconH>
          </div>
          {selectedBrandList.length > 0 && (
            <span style={{ fontWeight: "500", marginBottom: 10, fontSize: 13 }}>
              Marcas seleccionadas: {selectedBrandList.length}
            </span>
          )}
          <div className="tag-content" style={{ maxHeight: "max-content" }}>
            {selectedBrandList.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedBrandList((prevBrands) =>
                      prevBrands.filter((brand) => brand !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "5px",
              justifyContent: "flex-end",
              paddingBottom: 10,
            }}
          >
            <button
              className="cell-label"
              onClick={handleSelectAll}
              tabIndex={-1}
            >
              Seleccionar todos
            </button>
            |
            <button
              className="cell-label"
              onClick={handleCleanSelected}
              tabIndex={-1}
            >
              Limpiar selección
            </button>
          </div>
          <div className="delivery-note-table">
            <DataTable
              columns={columnsWithInputs}
              data={productList.filter(
                (e) =>
                  e.idProductoAlbaran !== "summary" &&
                  (selectedBrandList.length === 0 ||
                    selectedBrandList.includes(e.marca)),
              )}
              className="custom-datatable non-interactive"
              noDataComponent="No hay productos disponibles."
              selectableRows={false}
              customInputsTabIndexStart={tabStartIndex + 5}
              conditionalRowStyles={[
                {
                  when: (row) => row.validadoDatosCompra === true,
                  classNames: ["validated-product"],
                },
              ]}
            />
            {productList.filter(
              (e) =>
                e.idProductoAlbaran !== "summary" &&
                (selectedBrandList.length === 0 ||
                  selectedBrandList.includes(e.marca)),
            ).length > 0 && (
              <DataTable
                columns={columnsWithInputs}
                data={[currentSummary]}
                noDataComponent="No hay datos disponibles."
                className="custom-datatable summary-row no-header-datatable"
                noHeader
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
